import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const DominicaFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_14592'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_14592)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 5.6H20V0H0V5.6Z'
					fill='#108753'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H20V8.40002H0V14Z'
					fill='#108753'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M11.4286 14H8.57143V8.4H0V5.6H8.57143V0H11.4286V5.6H20V8.4H11.4286V14Z'
					fill='white'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M10.4762 14H9.52381V7.46667H0V6.53333H9.52381V0H10.4762V6.53333H20V7.46667H10.4762V14Z'
					fill='#262626'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M9.52381 14H8.57143V6.53333H0V5.6H8.57143V0H9.52381V5.6H20V6.53333H9.52381V14Z'
					fill='#FCD449'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M9.99935 10.2666C11.8403 10.2666 13.3327 8.80407 13.3327 6.99994C13.3327 5.19581 11.8403 3.73328 9.99935 3.73328C8.1584 3.73328 6.66602 5.19581 6.66602 6.99994C6.66602 8.80407 8.1584 10.2666 9.99935 10.2666Z'
					fill='url(#paint0_linear_2332_14592)'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M10.0001 9.33329C11.3151 9.33329 12.381 8.28862 12.381 6.99996C12.381 5.71129 11.3151 4.66663 10.0001 4.66663C8.68513 4.66663 7.61914 5.71129 7.61914 6.99996C7.61914 8.28862 8.68513 9.33329 10.0001 9.33329Z'
					stroke='#0E673F'
					strokeWidth='1.33333'
					strokeLinecap='round'
					strokeDasharray='0.67 2.67'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M10.0009 7.93332C10.5269 7.93332 10.4771 7.51545 10.4771 6.99998C10.4771 6.48452 10.5269 6.06665 10.0009 6.06665C9.4749 6.06665 9.5247 6.48452 9.5247 6.99998C9.5247 7.51545 9.4749 7.93332 10.0009 7.93332Z'
					fill='#0E673F'
				/>
			</g>
			<defs>
				<linearGradient
					id='paint0_linear_2332_14592'
					x1='6.66602'
					y1='3.73328'
					x2='6.66602'
					y2='10.2666'
					gradientUnits='userSpaceOnUse'>
					<stop stopColor='#E02C42' />
					<stop
						offset='1'
						stopColor='#D22036'
					/>
				</linearGradient>
			</defs>
		</svg>
	);
};

export default DominicaFlagIcon;
